import { Button, Flex, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter,
     ModalHeader, ModalOverlay, useDisclosure, useToast } from '@chakra-ui/react'
import React, { useEffect, useRef, useState } from 'react'
import { BsX } from 'react-icons/bs'
import { getEmail } from '../../classes/Email'
import { AL_INFO, defaultSelectData, useSelectedItemAlertContext } from '../../context/selectedItemAlertContext'
import { useUserContext } from '../../context/userContext'
import { BadgeEmailType, LabelInfo, TextDateFormat } from '../shared'
import { toastErrDesc, toastVal } from '../../utils/toastUtils'


const EmailInfoPreview = ({ emailData }) => {
    return (
        <Flex w="full" direction="column">
            <LabelInfo title="ชื่อแบบ">{emailData.name}</LabelInfo>
            <LabelInfo title="หัวเรื่อง">{emailData.title}</LabelInfo>
            <LabelInfo title="เนื้อเรื่อง">{emailData.body}</LabelInfo>
            <LabelInfo title="หมายเหตุ">{emailData.note}</LabelInfo>
            <LabelInfo title="ประเภท"><BadgeEmailType type={emailData.type} /></LabelInfo>
            <LabelInfo title="วันที่ปรับปรุง"><TextDateFormat value={emailData.updated_at} full /></LabelInfo>
        </Flex>
    )

}

const ModalEmailInfo = ({ data }) => {
    const { onClose, isOpen, onOpen } = useDisclosure()
    const { setItemData } = useSelectedItemAlertContext()
    const { userData } = useUserContext()
    const [infoData, setInfoData] = useState(null)
    const toast = useToast()

    const openModal = useRef()
    openModal.current = () => {
        if (data?.type === AL_INFO && data?.id) onOpen()
    }

    const loadData = useRef()
    loadData.current = async () => {
        // console.log(data)
        await getEmail(data?.id, userData.token)
            .then(res => {
                setInfoData(res)
                openModal.current()
            })
            .catch(error => {
                // console.log(error)
                toast(toastVal({
                    title: "การดึงข้อมูล ไม่สำเร็จ",
                    description: toastErrDesc(error),
                    status: "error",
                }))
            })
    }

    useEffect(() => {
        loadData.current()
    }, [data])

    const onCloseHandle = () => {
        setItemData(defaultSelectData)
        onClose()
    }
    return (
        <Modal isOpen={isOpen} onClose={onCloseHandle} size="4xl" motionPreset="slideInBottom">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>ข้อมูลรูปแบบอีเมล</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    {infoData && <EmailInfoPreview emailData={infoData} />}
                </ModalBody>
                <ModalFooter>
                    <Flex w="full" justify="center">
                        <Button leftIcon={<BsX />} colorScheme="blue" onClick={onCloseHandle}>
                            ปิดหน้าต่าง
                        </Button>
                    </Flex>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default ModalEmailInfo
